import React from 'react'
import SVG from 'react-inlinesvg';
import {styledComponent, getVal, getValFromTheme} from '/app/src/hoc'
import {Flex, Spinner} from '/app/src/component'

class AsyncSVGButton extends React.Component {
    constructor(props){
        super(props)
        this._onClick = this._onClick.bind(this)
    }
    _onClick(e){
        e.stopPropagation();
        e.target.value = this.props.text
        if(this.props.onClick) this.props.onClick(e)
    }
    render() {
        let {src, text, cursor,network,  ...rest} = this.props
        return (
            <Flex
                shrink={0}
                cursor={cursor || 'pointer'} center
                {...rest}
                position='relative'
                onClick={this._onClick}
                >
                {src && <SVG src={src} cacheGetRequests={true} /> }
                {text}
                {src && text &&<div style={{width:'10px'}}/>}
                {!network &&
                    <Flex
                        position='absolute'
                        height='100%'
                        width='100%'
                        background='rgba(250, 250, 250, 0.87)'
                        >
                    <Spinner  type='loading' /></Flex>}
            </Flex>
        );
    }
}

const StyledAsyncSVGButton =  styledComponent(AsyncSVGButton, props => ({
        'backgroundColor': props.active?getValFromTheme(props, ['backgroundHover'], props.theme.colors):'',
        'color': props.active? getValFromTheme(props, ['hover'], props.theme.colors):getValFromTheme(props, ['color'], props.theme.colors),
        'user-select': 'none',
        'direction': 'ltr',
        'border-radius': '10px',
        'border': props.border? '3px solid': undefined,
        'display': getVal(props, ['display']),
        ':hover >span>svg': {
            'fill': getValFromTheme(props, ['hover'], props.theme.colors),
        },
        '> span':{
            height: getVal(props, ['h', 'height'], '40px'),
            width: getVal(props, ['h', 'height'], '40px'),
        },
        '> span > svg':{
            height: getVal(props, ['h', 'height'], '100%'),
            width: getVal(props, ['h', 'height'], 'auto'),
            'fill': props.active? getValFromTheme(props, ['hover'], props.theme.colors):getValFromTheme(props, ['color'], props.theme.colors),
            'transform': 'scale(0.7)'
        }
}))

export default StyledAsyncSVGButton



// WEBPACK FOOTER //
// ./src/component/AsyncSVGButton/index.js